import React, { Fragment } from 'react';
import { compose } from 'recompose';
import { withLocale } from '../hocs/withLocale';
import {
  Fab,
  Grid,
  Typography,
  Paper,
  withStyles,
  Modal,
  SnackbarContent,
  Snackbar,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import moment from 'moment';
import { red } from '@material-ui/core/colors';

export const CookiesDisabled = compose(
  withStyles((theme) => ({
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    day: {
      padding: theme.spacing(1),
      flex: '1 0 auto',
    },
    footer: {
      padding: `${theme.spacing(1)}px 0`,
      zIndex: 1,
    },
    buttons: {
      '& > *': {
        flex: 1,
      },
    },
    button: {
      margin: `0 ${theme.spacing(1)}px`,
    },
    eventGroup: {
      flex: 1,
    },
    groupNames: {
      marginTop: theme.spacing(1),
    },

    groupName: {
      overflow: 'hidden',
      padding: theme.spacing(1),
    },
  })),
  withLocale
)(
  class extends React.Component {
    constructor(props) {
      super(props);
    }

    render = () => {
      return (
        <Snackbar
          style={{
            paddingTop: '50px',
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open
        >
          <SnackbarContent
            style={{ backgroundColor: red[400] }}
            message={this.props.translate('common.cookiesDisabled')}
          />
        </Snackbar>
      );
    };
  }
);
